export default __webpack_public_path__ + "static/media/laptop.20fa9aff.svg";